/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react'

import DealCard from '~/components/deal-card'
import { useEcommerceContext } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'
import { useClickoutUrl } from '~/hooks/useClickoutUrl'
import { trackKevelEvent } from '~/utils/kevel-tracking'
import { trackDealClick, getSegmentProps, clickAnchor } from '~/utils/tracking'

const P0 = ({ p0, ecommerce }) => {
  const {
    position,
    display: { adType, deal, kevelClickUrl, kevelImpressionUrl }
  } = p0

  const placementType = `p${position.position}`

  useEffect(() => {
    trackKevelEvent(kevelImpressionUrl)
  }, [kevelImpressionUrl])

  const dealLinkRef = useRef(null)

  const {
    data: { comparisonId }
  } = useEcommerceContext()

  const { listnames, pageId } = usePageContext()

  const clickoutLinkUrl = useClickoutUrl({
    deal,
    position: position.position,
    list: listnames().p0,
    placementType
  })

  const segmentProps = getSegmentProps({
    pageId,
    deal,
    comparisonId,
    position: position.position,
    dealUrl: clickoutLinkUrl,
    adType,
    placementType
  })

  const handleOnClick = (e) => {
    e.stopPropagation()

    if (e.target.tagName.toLowerCase() !== 'a') return clickAnchor(e, dealLinkRef)

    const eventLabelSuffix = e.target.getAttribute('data-is-more-info') === 'true' ? ' more info' : ''

    trackDealClick({ segmentProps, adType, ecommerce, kevelClickUrl, tenancy: true, eventLabelSuffix })
  }

  return (
    <DealCard
      deal={{ ...deal, isSponsored: true }}
      position={position.position}
      adType={adType}
      placementType={placementType}
      href={clickoutLinkUrl}
      onClick={handleOnClick}
      dealLinkRef={dealLinkRef}
      isSponsored
      asMobileCard
      cityFibreDealsAvailable
    />
  )
}

export default P0
